import * as Tone from 'tone';
import AudioEffect from './AudioEffect';
import { optionsFromArguments } from 'tone';
class Compressor extends AudioEffect {
    constructor() {
        super();
        const options = optionsFromArguments(defaults, arguments, // eslint-disable-line prefer-rest-params
        ['threshold', 'gain', 'attack', 'release', 'ratio']);
        this.compressor = new Tone.Compressor({
            threshold: options.threshold,
            ratio: options.ratio,
            attack: options.attack,
            release: options.release
        });
        this.gainNode = new Tone.Gain(options.gain, "decibels");
        this.compressor.connect(this.gainNode);
    }
    input() { return this.compressor; }
    output() { return this.gainNode; }
    get threshold() {
        return this.compressor.threshold;
    }
    get ratio() {
        return this.compressor.ratio;
    }
    get gain() {
        return this.gainNode.gain;
    }
    get attack() {
        return this.compressor.attack;
    }
    get release() {
        return this.compressor.release;
    }
}
const defaults = {
    threshold: 0,
    gain: 0,
    attack: 0.002,
    release: 0.05,
    ratio: 2
};
export default Compressor;
//# sourceMappingURL=Compressor.js.map